import React from 'react';

class EditSectionTextArea extends React.Component {
  constructor( props ){
    super( props );
    this.state = {
      columnName: props.columnName === undefined ? '' : props.columnName,
      value: props.value === undefined ? '' : props.value,
      readonly: props.readonly === undefined ? false : true,
      autoFocus: props.autoFocus === undefined ? false : true,
      placeholder: props.placeholder === undefined ? '' : props.placeholder,
      height: props.height === undefined ? 'auto' : props.height,
      width: props.width === undefined ? 'auto' : props.width,
      maxLength: props.maxLength === undefined ? 524288 : props.maxLength,
      alert: '',
      hasError: false,
      error: {},
      info: {}
    };

    // Bound Component Events
    this.onChange = this.onChange.bind( this );
  }

  componentDidCatch( error, info ) {
    this.setState( {
      hasError: true,
      error: error,
      info: info
    } );
  }

  componentWillReceiveProps( nextProps ) {
    if( this.compareProps( this.props, nextProps ) === true ) {
      this.setState( { 
        columnName: nextProps.columnName === undefined ? '' : nextProps.columnName,
        value: nextProps.value,
        readonly: nextProps.readonly === undefined ? false : true,
        autoFocus: nextProps.autoFocus === undefined ? false : nextProps.autoFocus,
        placeholder: nextProps.placeholder === undefined ? '' : nextProps.placeholder,
        height: nextProps.height === undefined ? 'auto' : nextProps.height,
        width: nextProps.width === undefined ? 'auto' : nextProps.width,
        maxLength: nextProps.maxLength === undefined ? 524288 : nextProps.maxLength
      } );
    }
  }

  compareProps( props, nextProps ) {

    if( props.columnName !== nextProps.columnName ) {
      return true;
    }

    if( props.value !== nextProps.value ) {
      return true;
    }

    const cReadOnly = props.readonly === undefined ? false : true;
    const nReadOnly = nextProps.readonly === undefined ? false : true;
    if( cReadOnly !== nReadOnly ) {
      return true;
    }

    const cAutoFocus = props.autoFocus === undefined ? false : true;
    const nAutoFocus = nextProps.autoFocus === undefined ? false : true;
    if( cAutoFocus !== nAutoFocus ) {
      return true;
    }

    if( props.placeholder !== nextProps.placeholder ) {
      return true;
    }

    if( props.height !== nextProps.height ) {
      return true;
    }

    if( props.width !== nextProps.width ) {
      return true;
    }

    if( props.maxLength !== nextProps.maxLength ) {
      return true;
    }

    return false;
  }

  onChange( e ){

    if( this.props.onChanged !== undefined ){

      e.target.column = this.state.columnName;

      this.props.onChanged( e );

    } else {

      this.setState( {value: e.target.value} );
    }

  }

  render(){
    const id = this.props.id;
    const disabled = this.state.disabled === undefined ? false : this.state.disabled;
    const placeholder = this.state.placeholder === undefined ? '' : this.state.placeholder;
    const height = this.state.height === undefined ? 'auto' : this.state.height;
    const width = this.state.width === undefined ? 'auto' : this.state.width;
    const visible = this.state.visible === undefined ? true : this.state.visible;
    const autoFocus = [undefined, null, false].includes( this.state.autoFocus ) ? false : true;
    const maxLength = this.state.maxLength === undefined ? '524288' : this.state.maxLength;
    let className = this.state.alert === true ? 'edit-section-textarea alert' : 'edit-section-textarea';

    let styles = {
      'width': width,
      'height': height,
      'fontSize': '100%',
    };

    let readonly = this.props.readonly;
    let opts = {};

    if( readonly === true ) {
      opts['readonly'] = 'readonly';
    }

    if( ( visible === false ) || ( this.state.hasError === true ) ) {
      return(
        <div></div>
      );
    } else {
      return (
        <textarea
          id={id}
          type="text"
          autoFocus={autoFocus}
          disabled={disabled}
          className={className}
          placeholder={placeholder}
          value={this.state.value}
          style={styles}
          onChange={this.onChange}
          {...opts}
          maxLength={maxLength}
        />
      );
    }
  }
}

export default EditSectionTextArea;



// WEBPACK FOOTER //
// ./src/presentation/EditSectionTextArea.js